import { Divider } from "@circleco/compass/components/Divider";
import { Icon } from "@circleco/compass/components/Icon";

import type { CommunityRow } from "./useCommunityHeaderRows";

interface CommunityHeaderRowsProps {
  onRowClick?: (row: Exclude<CommunityRow, "divider">) => void;
  rows: CommunityRow[];
}

export const CommunityHeaderRows = ({
  onRowClick,
  rows,
}: CommunityHeaderRowsProps) => (
  <div className="flex min-w-56 flex-col py-1">
    {rows.map((row, index) =>
      row === "divider" ? (
        // eslint-disable-next-line react/no-array-index-key -- dividers carry no stable id
        <Divider key={`divider-${index}`} className="my-1" />
      ) : (
        <button
          key={row.label}
          type="button"
          onClick={() => {
            row.onClick();
            onRowClick?.(row);
          }}
          className="hover:bg-secondary flex w-full items-center gap-4 px-4 py-2 text-left transition-colors duration-150 ease-linear"
        >
          {row.prefix ??
            (row.icon ? (
              <Icon
                name={row.icon}
                size="sm"
                className="shrink-0"
                color="secondary"
              />
            ) : null)}
          <span className="text-dark flex-1 truncate text-sm">{row.label}</span>
          {row.suffix}
        </button>
      ),
    )}
  </div>
);
